
<svg viewBox="0 0 100 100"
     preserveAspectRatio="xMidYMid meet">
  <path></path>
</svg>
